import { BsArrowRight } from "react-icons/bs";

export function money(value) {
  return `SEK ${Number(value || 0).toLocaleString()}`;
}

export function deltaClass(value) {
  return Number(value || 0) >= 0 ? "text-green-600" : "text-red-600";
}

export function priorityBadge(priority) {
  const normalizedPriority = String(priority || "").toLowerCase();

  if (
    normalizedPriority.includes("high") ||
    normalizedPriority.includes("p1")
  ) {
    return "🔴 High";
  }
  if (
    normalizedPriority.includes("medium") ||
    normalizedPriority.includes("p2")
  ) {
    return "🟡 Medium";
  }
  return "🟢 Low";
}

export function renderWithArrow(text, keyPrefix = "line") {
  const parts = String(text || "").split("->");
  if (parts.length === 1) return <span>{text}</span>;

  return (
    <span>
      {parts.map((part, index) => (
        <span key={`${keyPrefix}-${index}`}>
          {index > 0 ? <BsArrowRight className="inline mx-1" /> : null}
          {part.trim()}
        </span>
      ))}
    </span>
  );
}

export function formatYmd(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatSuggestedDueDate(dateString) {
  if (!dateString) return "-";

  const dueDate = new Date(`${dateString}T00:00:00`);
  if (Number.isNaN(dueDate.getTime())) return dateString;

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const differenceInDays = Math.round(
    (dueDate.getTime() - today.getTime()) / millisecondsPerDay,
  );

  if (differenceInDays < 0) return "Overdue";
  if (differenceInDays === 0) return "Today";
  if (differenceInDays === 1) return "Tomorrow";
  if (differenceInDays <= 7) return "This Week";
  return formatYmd(dueDate);
}

export function formatDateTime(value) {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export function pct(value) {
  return `${Number(value || 0).toFixed(1)}%`;
}

export function toChangePct(current, previous) {
  const currentValue = Number(current || 0);
  const previousValue = Number(previous || 0);

  if (!previousValue) return currentValue === 0 ? 0 : 100;
  return ((currentValue - previousValue) / previousValue) * 100;
}
